import { Paper, Typography, Select, MenuItem } from "@mui/material";

const SignatureAbilityNodeEdit = ({ editedItem, index, appFiles, setAppFiles }) => {

    const sigAbilities = JSON.parse(appFiles.signatureAbilities || '[]');

    const handleEdit = (newItem) => {
        let newFiles = { ...appFiles };
        let newCat = JSON.parse(appFiles["signatureAbilityNodes"]);
        newCat[index] = newItem;
        newFiles["signatureAbilityNodes"] = JSON.stringify(newCat);
        setAppFiles(newFiles);
        localStorage.setItem('appFiles', JSON.stringify(newFiles));
    };

    const options = sigAbilities
        .map((a) => a.Name)
        .filter((name, i, arr) => name && arr.indexOf(name) === i)
        .sort((a, b) => a.localeCompare(b));

    const current = editedItem.SigAbility || '';
    const isKnown = options.includes(current);

    return (
        <Paper>
            <Typography>Tied To Signature Ability:</Typography>
            <Select
                value={current}
                onChange={(e) => handleEdit({ ...editedItem, SigAbility: e.target.value })}
                sx={{ minWidth: "260px" }}
                displayEmpty
            >
                <MenuItem value="">(none)</MenuItem>
                {!isKnown && current && (
                    <MenuItem value={current}>{current}</MenuItem>
                )}
                {options.map((name) => (
                    <MenuItem key={name} value={name}>{name}</MenuItem>
                ))}
            </Select>
        </Paper>
    )
}

export default SignatureAbilityNodeEdit
